import {
  BreakConfigurationsDataTableDocument,
  CreateBreakConfigurationDocument,
  CreateBreakConfigurationMutation,
  CreateBreakConfigurationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateBreakConfiguration = () => {
  const [createBreakConfiguration, { loading }] = useMutation(CreateBreakConfigurationDocument, {
    extractorFn: (data: CreateBreakConfigurationMutation) =>
      data.timeSettingsMutations.createTimesettingsBreakConfiguration,
  })
  return {
    loading,
    create(variables: CreateBreakConfigurationMutationVariables) {
      return createBreakConfiguration({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [{ query: BreakConfigurationsDataTableDocument }],
      })
    },
  }
}
